export function formatResponse(response) {
    return {
        data: response.data,
        isSuccess: response.status >= 200 && response.status < 300,
        status: response.status,
        statusText: response.statusText
    };
}
